import React from "react";
import "./PuertoBanner.css";

import { Button } from "../../Components/Button/Button";
import { Link } from "react-router-dom";

export const PuertoBanner = () => {
  return (
    <section className="puerto-banner">
      <div className="puerto-banner__content">
        <div className="puerto-banner__text">
          <h2 className="puerto-banner__headline">
            <span role="img" aria-label="mexican-flag">
              🇲🇽
            </span>{" "}
            Puerto Escondido Nominated as the Next World Surfing Reserve!
          </h2>

          <p className="puerto-banner__text">
            <strong>@SaveTheWavesCoalition</strong> has nominated Puerto
            Escondido as the <strong>14th World Surfing Reserve</strong> to
            protect legendary waves like <strong>Zicatela</strong> and{" "}
            <strong>Punta Colorada</strong>, and preserve over 10 km of surf
            ecosystems in this iconic Mexican surf haven!
          </p>

          <blockquote className="puerto-banner__quote">
            “Zicatela is not just a beach; it is our identity, our history, our
            life. Being recognized as a World Surfing Reserve is an honor, but
            also a responsibility.”
            <br />
            <span>– Humberto “Beto” Olivera</span>
          </blockquote>

          <p className="puerto-banner__text">
            This nomination will help recognize and protect the{" "}
            <strong>waves, biodiversity, and community</strong> that make Puerto
            Escondido an international treasure. Save The Waves is proud to
            continue working alongside <strong>@salvemoscolorada</strong>,{" "}
            <strong>@costaunida</strong>, <strong>@sospuerto</strong>, and{" "}
            <strong>@fondoax</strong> to safeguard this paradise for generations
            to come!
          </p>

          <Link
            to="https://www.savethewaves.org/puertoescondido/"
            target="_blank"
          >
            <Button text="Learn More" type="outline" size="small" />
          </Link>
        </div>
      </div>
    </section>
  );
};
